import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Fade from '@mui/material/Fade';
import { keyframes } from '@mui/material/styles';

const titleReveal = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.92);
    letter-spacing: 0.45em;
    filter: blur(10px);
    text-shadow: 0 0 30px rgba(122, 30, 44, 0.45);
  }
  35% {
    opacity: 1;
    transform: scale(1);
    letter-spacing: 0.22em;
    filter: blur(0);
    text-shadow: 0 0 12px rgba(122, 30, 44, 0.22);
  }
  70% {
    opacity: 1;
    transform: scale(1);
    letter-spacing: 0.12em;
    filter: blur(0);
    text-shadow: 0 0 8px rgba(122, 30, 44, 0.18);
  }
  100% {
    opacity: 1;
    transform: scale(1);
    letter-spacing: 0.08em;
    filter: blur(0);
    text-shadow: 0 0 2px rgba(122, 30, 44, 0.1);
  }
`;

const subtitleReveal = keyframes`
  0% {
    opacity: 0;
    transform: translateY(24px) scale(0.98);
    letter-spacing: 0.18em;
    filter: blur(8px);
  }
  40% {
    opacity: 0;
    transform: translateY(24px) scale(0.98);
    letter-spacing: 0.18em;
    filter: blur(8px);
  }
  70% {
    opacity: 0.95;
    transform: translateY(0) scale(1);
    letter-spacing: 0.06em;
    filter: blur(0);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
    letter-spacing: 0.02em;
    filter: blur(0);
  }
`;

const softPulse = keyframes`
  0% {
    opacity: 0.92;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.01);
  }
  100% {
    opacity: 0.95;
    transform: scale(1);
  }
`;

export default function IntroScreen() {
  return (
    <Fade in timeout={500}>
      <Box
        sx={{
          minHeight: '100vh',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 3,
          background: 'linear-gradient(135deg, #ffffff 0%, #f7f1f1 100%)',
          overflow: 'hidden',
          position: 'relative'
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            background: 'radial-gradient(circle at center, rgba(122,30,44,0.08) 0%, rgba(255,255,255,0) 55%)',
            pointerEvents: 'none',
            animation: `${softPulse} 2.8s ease-in-out infinite`
          }}
        />

        <Box
          sx={{
            textAlign: 'center',
            maxWidth: 950,
            position: 'relative',
            zIndex: 1
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontWeight: 800,
              color: '#7A1E2C',
              mb: 2,
              fontSize: { xs: '2.3rem', sm: '3rem', md: '4rem' },
              lineHeight: 1.1,
              textTransform: 'uppercase',
              animation: `${titleReveal} 1.8s ease-out forwards`
            }}
          >
            PH-NX
          </Typography>

          <Typography
            variant="h4"
            sx={{
              fontWeight: 400,
              color: 'text.secondary',
              lineHeight: 1.5,
              fontSize: { xs: '1rem', sm: '1.25rem', md: '1.6rem' },
              maxWidth: 900,
              mx: 'auto',
              animation: `${subtitleReveal} 2.4s ease-out forwards`
            }}
          >
            Digital Brain for Strategic Thinking and Legacy Transfer
          </Typography>
        </Box>
      </Box>
    </Fade>
  );
}
